import { Injectable } from '@angular/core';
declare let gtag: Function;
declare let fbq: Function;

// ga4tracking.service.ts
@Injectable({ providedIn: 'root' })
export class Ga4trackingService {
  private static readonly CT_QUEUE_KEY = 'ctQueuedEvents';

  private storeEvent(eventName: string, eventParams: any) {
    // fallback storage in localStorage if the SDK is not ready
    try {
      const current = JSON.parse(localStorage.getItem(Ga4trackingService.CT_QUEUE_KEY) || '[]');
      current.push({ eventName, eventParams });
      localStorage.setItem(Ga4trackingService.CT_QUEUE_KEY, JSON.stringify(current));
    } catch (e) {
      console.error('Could not queue event in localStorage', e);
    }
  }

  flushQueuedEvents() {
    try {
      const queued: Array<{ eventName: string; eventParams: any }> =
        JSON.parse(localStorage.getItem(Ga4trackingService.CT_QUEUE_KEY) || '[]');
      const ct = (window as any).clevertap;
      if (ct && Array.isArray(ct.event)) {
        queued.forEach(({ eventName, eventParams }) => {
          ct.event.push(eventName, eventParams);
        });
      }
      localStorage.removeItem(Ga4trackingService.CT_QUEUE_KEY);
    } catch (e) {
      console.error('Failed to flush queued events', e);
    }
  }

  customGa4Tracking(eventType: string, method: string, attributes: any) {
    // GA4 and Meta Pixel logic unchanged…
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ event: eventType, method, attributes });
    fbq('trackCustom', eventType, attributes);

    // CleverTap logic:
    const ct = (window as any).clevertap;
    if (ct && Array.isArray(ct.event)) {
      ct.event.push({ action: eventType, ...attributes });
    } else {
      // SDK not ready: persist event
      this.storeEvent(eventType, attributes);
    }
  }

  sendEvent(eventName: string, eventParams: any = {}) {
    // GA4 and Meta Pixel
    gtag('event', eventName, eventParams);
    fbq('trackCustom', eventName, eventParams);

    // CleverTap
    const ct = (window as any).clevertap;
    if (ct && Array.isArray(ct.event)) {
      ct.event.push(eventName, eventParams);
    } else {
      this.storeEvent(eventName, eventParams);
    }
  }
  sendStandardEvent(eventName: string, eventParams: any = {} ) {
    // Meta Pixel
    fbq('track', eventName, eventParams);
  }
}
